import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';

import { onLogout } from '../../actions/authActions';

interface ILogoutProps {
    onLogout: any
}

const logout: React.FC<ILogoutProps> = (props) => {
  const { onLogout } = props;
 
  useEffect(() => {
    onLogout();
  }, [onLogout]);

  return <Navigate to="/login" />;
};

const mapDispatchToProps = {
    onLogout,
  };

  
export default connect(
  null,
  mapDispatchToProps
)(logout);
